module.exports = __webpack_public_path__ + "img/desarrollo-1-1040.e13b0bce.webp";